export default __webpack_public_path__ + "static/media/print-logo.3a4c0f2d.png";